module.exports = __webpack_public_path__ + "static/media/KitchenAidCard.d7331669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registryOnboard/KitchenAidCard.png
// module id = 2019
// module chunks = 51